import { ConsoleContext } from "../../../../mobxStores/consoleContext/consoleContext";
import { TableColumn } from "../../types";
import { InternalLink } from "../../components/InternalLink";

const userNameDescriptionDefault = { id: "email", label: "Email" };
export function UserNameDescriptionColumn<TData extends { email: string; name: string; kind: string }>(
  column: Partial<TableColumn<TData>> = userNameDescriptionDefault,
) {
  const preset: TableColumn<TData> = {
    ...userNameDescriptionDefault,
    enableResize: true,
    enableSort: true,
    size: 200,
    cell: (p) => {
      const item = p.row.original;
      let link = `/console/org/${ConsoleContext.org}/${item.kind}/${item.email}`;

      return (
        <div className="flex flex-col justify-center" style={{ height: 56 }}>
          <InternalLink label={item.email} to={link} />
          <span className="text-sm description">{item.name}</span>
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
